import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Flow} from "../../../initializeFlows";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme.js";

export class DonatePanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content = {
        ...this.themeProps.PANEL_PAGE_STYLE,
    }

    @styleRule
    button = {
        width: "100%",
        marginTop: 18,
    }
}

@registerStyle(DonatePanelStyle)
export class DonatePanel extends BasePanelPage {
    render() {
        return [
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton
                label={Flow.donation.getDonateComponentButtonLabel()}
                disabled={!Flow.donation.isValid()}
                onClick={() => this.donate()}
                className={this.styleSheet.button}/>,
        ];
    }

    donate() {
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    onMount() {
        super.onMount();

        this.redraw(); // This is for the first rendering where the button doesn't have a label.
    }
}
